import { render, staticRenderFns } from "./AvaLoader.vue?vue&type=template&id=032d3bc9&scoped=true"
import script from "./AvaLoader.vue?vue&type=script&lang=js"
export * from "./AvaLoader.vue?vue&type=script&lang=js"
import style0 from "./AvaLoader.vue?vue&type=style&index=0&id=032d3bc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d3bc9",
  null
  
)

export default component.exports